module.exports = __webpack_public_path__ + "img/double-explosure1.5150cf7c.png";